var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHashTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72501 5H13C13.2761 5 13.5 4.77614 13.5 4.5C13.5 4.22386 13.2761 4 13 4H1.72501C1.44886 4 1.22501 4.22386 1.22501 4.5C1.22501 4.77614 1.44886 5 1.72501 5Z",
    fill: "#5932EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50812 11.9103C7.50275 11.9398 7.5 11.97 7.5 12L7.50005 12.0073C7.5015 12.1065 7.53243 12.203 7.5889 12.2846C7.66439 12.3936 7.78009 12.4682 7.91056 12.4919C7.94007 12.4973 7.97 12.5 8 12.5L8.00156 12.5C8.24262 12.4992 8.44881 12.3266 8.49193 12.0894L10.4919 1.08944C10.4973 1.05993 10.5 1.03 10.5 1L10.4999 0.992708C10.4985 0.893502 10.4676 0.79697 10.4111 0.715395C10.3356 0.606366 10.2199 0.531787 10.0894 0.508065C10.0599 0.502699 10.03 0.5 10 0.5L9.99844 0.500002C9.75738 0.500757 9.55119 0.673392 9.50807 0.910557L7.50812 11.9103Z",
    fill: "#5932EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50812 11.9103C3.50275 11.9398 3.5 11.97 3.5 12L3.50005 12.0073C3.5015 12.1065 3.53243 12.203 3.5889 12.2846C3.66439 12.3936 3.78009 12.4682 3.91056 12.4919C3.94007 12.4973 3.97 12.5 4 12.5L4.00156 12.5C4.24262 12.4992 4.44881 12.3266 4.49194 12.0894L6.49193 1.08944C6.4973 1.05993 6.5 1.03 6.5 1L6.49995 0.992708C6.4985 0.893502 6.46757 0.79697 6.4111 0.715395C6.33561 0.606366 6.21991 0.531787 6.08944 0.508065C6.05993 0.502699 6.03 0.5 6 0.5L5.99844 0.500002C5.75738 0.500757 5.55119 0.673392 5.50807 0.910557L3.50812 11.9103Z",
    fill: "#5932EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H12.275C12.5511 9 12.775 8.77614 12.775 8.5C12.775 8.22386 12.5511 8 12.275 8H1C0.723858 8 0.5 8.22386 0.5 8.5C0.5 8.77614 0.723858 9 1 9Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashTags);
export default __webpack_public_path__ + "static/media/hash-tags.6504b8fa80df215addf5d258d84516b4.svg";
export { ForwardRef as ReactComponent };